<template>
<div class="full-page-width" :key="`all-shipments-${$route.query ? $route.query.globalSearchKey : 0}`">
  <div class="all-shipments relative">
    <div class="add-button c-float m-b-20 flex is-flex-wrap">
      <div class="flex" style="flex-grow: 1">
        <p class="user-name">{{ $t('all_shipments') }}</p>
      </div>
      <Dropdown
        class="flex drop-right"
        :buttonText="$t('add')"
        :dropdownOptions="dropdownOptions"
        @optionSelected="optionSelected" />
    </div>
    <DataTable
      :dropdown=false
      :tableHeader=false
      :tableHead=true
      tableAPI="SHIPMENTS"
      tableActions="SHIPMENTS"
      :actionsOptions="actionsOptions"
      :totalCount="totalCount"
      :checkbox=true
      :type=type
      :count="get_shipments_count"
      :list="get_shipments_list"
      :rowActionParameter="rowActionParameter"
      :customTable="tableType"
      :referenceData="referenceData"
      :filterOptions="filterOptions"
      :updateIterator="updateIterator"
      @updatedSelections="tableSelectionsUpdated"
      @actionOptionTriggered="actionOptionTriggered"
      @rowAction="rowAction" />
    <a
      style="display: none"
      :download="`Waybills`"
      ref="downloadWaybillsPDF"
      :href="waybillsPdfPath" />
  </div>
  <Popup
    v-if="openImport"
    :showConfirmButton="showImportButton && !get_error_message"
    :confirmText="$t('import')"
    @cancel="togglePopupEdit"
    @confirm="submitForm">
    <template v-slot:header>
      <h2>{{ $t('Import Template') }}</h2>
    </template>
    <UploadTemplate
      @enabeImport="enableImport"
      @disableImport="showImportButton = false"
      @closePopup="closePopupAndTrackImportProcess"
      templateType="shipment_fields" />
      <message v-if="get_error_message.type" name="warning" :data="get_error_message"></message>
  </Popup>
  <Popup v-if="showManualCancelPopup" :showConfirmButton="true" :showCancelButton="false" :confirmText="$t('got_it')" @confirm="closeManualCancelPopup"  @cancel="closeManualCancelPopup">
    <template v-slot:header>
      <h2>{{ $t('shippment_not_cancelled') }}</h2>
    </template>
    <div>
        <message name="warning" :data="data={data:information, type:'custom-message'}" v-for="(information, index) in shippmentManualCancel" :key="`error-${index}`"></message>
    </div>
  </Popup>
  <Popup v-if="showManualCancelPopup" :showConfirmButton="true" :showCancelButton="false" :confirmText="$t('got_it')" @confirm="closeManualCancelPopup"  @cancel="closeManualCancelPopup">
    <template v-slot:header>
      <h2>{{ $t('shippment_not_cancelled') }}</h2>
    </template>
    <div>
      <message name="warning" :data="data={data:information, type:'custom-message'}" v-for="(information, index) in shippmentManualCancel" :key="`error-${index}`"></message>
    </div>
  </Popup>
  <Popup
    v-if="showLastInPickupPopup"
    :showConfirmButton="false"
    :showCancelButton="true"
    @cancel="closeLastInPickupPopup"
  ><div>
    <!-- Loop through each empty pickup -->
    <div v-for="(pickup, index) in emptyPickups" :key="index" class="m-b-20">
      <div class="message-conatiner flex" style="background-color: #FCF8E3; border-color: #FAEBCC;">
        <div class="m-r-10 message-box" style="align-self:flex-start;">
          <Icon
            class="m-r-20"
            style="background-color: #F7F0C9"
            :circle=true
            fillColor="#755D32"
            name="warningSign"
            size="22"/>
        </div>
        <div class="custom-message">
          <p style="color: #755D32">
            {{ $t('shipment_is_in_scheduled_pickup', { trace_nos: pickup.shipment_trace_nos }) }}
            {{ $t('do_you_want_to_cancel_pickup') }}
          </p>
          <div class="m-t-20">
            <div class="clear-float" style="margin-top: auto">
              <Btn
                @click.native="keepPickup(index)"
                class="brand float-left m-r-20"
                style="background-color: black; color: white"
                :icon="{
                    name: 'check',
                    size: '18',
                  }"
                :btnText="$t('keep_the_pickup')"
              />
              <Btn
                @click.native="cancelPickup(pickup, index)"
                class="red float-left m-r-20"
                :icon="{
                    name: 'deleteForever',
                    size: '18',
                  }"
                :btnText="$t('cancel_the_pickup')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </Popup>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Dropdown from '@/components/global/dropdown';
import Btn from '@/components/elements/buttons';
import DataTable from '@/components/table/index.vue';
import Popup from '@/components/global/popup';
import UploadTemplate from '@/components/global/uploadTemplate';
import EventBus from '@/eventBus.js';
import i18n from '../../i18n';

/* eslint-disable */
export default {
  name: 'AllShipments',
  components: { DataTable, Btn, Dropdown, Popup, UploadTemplate },
  data() {
    return {
      showLastInPickupPopup: false,
      emptyPickups: [], // List of empty pickups
      currentPickupIndex: 0, // Index of the currently selected pickup
      shippmentManualCancel: {},
      showManualCancelPopup: false,
      isTableAllSelected: false,
      openImport: false,
      showImportButton: false,
      updateIterator: 1,
      totalCount: 10,
      rowActionParameter: {
        param: 'id',
        text: this.$t('View shipment'),
      },
      type: {
        type: false,
        data: 'status',
      },
      referenceData: [
        {
          created_at: `${this.$t('created_at')}`,
          creator_user_name: `${this.$t('created_by')}`,
        },
        {
          customer_name: `${this.$t('receiver')}`,
          customer_address_country_name: `${this.$t('country')}`,
        },
        {
          sender_reference: `${this.$t('Sender ref.:')}`,
          create_type: `${this.$t('Source')}`,
        },
      ],
      dropdownOptions: [
        {
          text: `${this.$t('Create Shipment')}`,
          subText: `${this.$t('Type in manually')}`,
          icon: 'plus',
        },
        {
          text: `${this.$t('upload_shipments')}`,
          subText: `${this.$t('Bulk import from file')}`,
          icon: 'cloudUpload',
        },
      ],
      actionsOptions: [
        {
          text: this.$t('copy_to_new'),
          subText: this.$t('Create with copied data'),
          icon: 'fileCopies',
        },
        {
          text: this.$t('Create EOD'),
          subText: this.$t('Create end of day'),
          icon: 'delivery',
        },
        {
          text: this.$t('Download waybills'),
          subText: this.$t('Download waybills'),
          icon: 'cloudDownload',
        },
        {
          text: this.$t('cancel'),
          subText: this.$t('Cancel shipment'),
          icon: 'deleteForever',
        },
      ],
      waybillsPdfPath: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_error_message',
      'get_shipments_list',
      'get_shipments_count',
      'get_shipments_ids_of_all_records',
      'get_filters_menu',
      'get_active_filter',
      'get_all_shipments_query',
      'get_active_subaccount'
    ]),
    tableType() {
      return 'AllShipments';
    },
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'allShipments',
        tableApi: 'shipment/get-list',
        filterFields: {
          status: {
            label: this.$t('status'),
            type: 'select',
            multiselect: true,
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: this.$t('canceled'), value: '5'},
              {text: this.$t('PRINTED'), value: '3'},
              {text: this.$t('Recived by agent'), value: '12'},
              {text: this.$t('on_the_way'), value: '13'},
              {text: this.$t('deviation'), value: '16'},
              {text: this.$t('In pickup point'), value: '15'},
              {text: this.$t('Delivered'), value: '14'},
              {text: this.$t('Return_1'), value: '6'},
              {text: this.$t('Waiting for approval'), value: '34'},
              {text: this.$t('Approved'), value: '35'},
            ],
          },
          ship_date: {
            label: this.$t('ship_date'),
            type: 'date',
            range: true,
            value: {
              value: null,
              additional: '',
            },
          },
          created_at: {
            label: this.$t('created_at'),
            type: 'date',
            range: true,
            value: {
              value: null,
              additional: '',
            },
          },
          subaccounts: {
            label: this.$t('account'),
            type: 'subaccount',
            value: {
              value: [],
              additional: '',
            },
          },
          custom_tags: {
            label: this.$t('Tags'),
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          shipping_agents: {
            label: this.$t('shipping_agent_name'),
            type: 'shippingAgent',
            value: {
              value: [],
              additional: '',
            },
          },
          shipping_product_name: {
            label: this.$t('Product name'),
            type: 'shippingProduct',
            multiselect: true,
            value: {
              value: [],
              additional: '',
            },
          },
         /* goods_type: {
            label: this.$t('goods_type'),
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('parcel')}`, value: '1'},
              {text: `${this.$t('document')}`, value: '2'},
              {text: `${this.$t('pallet')}`, value: '3'},
              {text: `${this.$t('load')}`, value: '4'},
            ],
          },*/
          receiver_reference: {
            label: `${this.$t('reciever_reference')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_company_name: {
            label: `${this.$t('receiver_company_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_name: {
            label: `${this.$t('receiver_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_address: {
            label: `${this.$t('receiver_address')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_post_code: {
            label: `${this.$t('receiver_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          receiver_country_id: {
            label: `${this.$t('receiver_country_id')}`,
            type: 'country',
            noContinent: true,
            value: {
              value: [],
              additional: '',
            },
          },
          sender_reference: {
            label: `${this.$t('sender_reference')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_company_name: {
            label: `${this.$t('sender_company_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_name: {
            label: `${this.$t('sender_name')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_address: {
            label: `${this.$t('sender_address')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_post_code: {
            label: `${this.$t('sender_post_code')}`,
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          sender_country_id: {
            label: `${this.$t('sender_country_id')}`,
            type: 'country',
            noContinent: true,
            value: {
              value: [],
              additional: '',
            },
          },
          goods_incoterm: {
            label: `${this.$t('goods_incoterm')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: 'DAP', value: 'DAP'},
              {text: 'DDP', value: 'DDP'},
              {text: 'EXW', value: 'EXW'},
              {text: 'FCA', value: 'FCA'},
              {text: 'CPT', value: 'CPT'},
              {text: 'CIP', value: 'CIP'},
              {text: 'DPU', value: 'DPU'},
              {text: 'FAS', value: 'FAS'},
              {text: 'FOB', value: 'FOB'},
              {text: 'CFR', value: 'CFR'},
              {text: 'CIF', value: 'CIF'},
            ],
          },
          duty_paid_by: {
            label: `${this.$t('duty_paid_by')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('duty_paid_by')} ${this.$t('Seller').toLowerCase()}`, value: '1'},
              {text: `${this.$t('duty_paid_by')} ${this.$t('Reciever').toLowerCase()}`, value: '2'},
              {text: `${this.$t('duty_paid_by')} ${this.$t('Third party').toLowerCase()}`, value: '3'},
            ],
          },
          freight_paid_by: {
            label: `${this.$t('freight_paid_by')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('freight_paid_by')} ${this.$t('Seller').toLowerCase()}`, value: '1'},
              {text: `${this.$t('freight_paid_by')} ${this.$t('Other').toLowerCase()}`, value: '2'},
            ],
          },
          dangerous_goods: {
            label: `${this.$t('dangerous_goods')}`,
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: `${this.$t('yes')}`, value: '1'},
              {text: `${this.$t('no')}`, value: '0'},
            ],
          },
        },
      }
    },
  },
  methods: {
    // Method to handle keeping a pickup
    keepPickup(index) {
      // Remove this pickup from the list without canceling it
      this.emptyPickups.splice(index, 1);

      // If all pickups have been decided upon, close the popup
      if (this.emptyPickups.length === 0) {
        this.closeLastInPickupPopup();
      }
    },
    // Method to handle canceling a pickup
    cancelPickup(pickup, index) {
      console.log(pickup)
      // Cancel the pickup
      this.$store.dispatch('CANCEL_PICKUP', {id: pickup.pickup_id}).then(() => {
        this.updateIterator++;

        // Show notification
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: this.$t('pickup_cancelled_successfully', { number: pickup.id }),
          type: 'success-window',
          iconName: 'check',
        });

        // Remove the cancelled pickup from the list
        this.emptyPickups.splice(index, 1);

        // If all pickups have been decided upon, close the popup
        if (this.emptyPickups.length === 0) {
          this.closeLastInPickupPopup();
        }
      });
    },
    // Method to close the popup
    closeLastInPickupPopup() {
      this.showLastInPickupPopup = false;
      this.emptyPickups = [];
    },
    // Table actions
    tableSelectionsUpdated(val) {
      this.isTableAllSelected = val.selectTotalRows;
    },
    // import
    openImportTemplatePopup() {
      this.openImport = true;
      this.$store.dispatch('GET_TEMPLATES');
    },
    togglePopupEdit() {
      this.openImport = !this.openImport;
    },
    submitForm() {
      EventBus.$emit('import_template');
    },
    enableImport() {
      this.showImportButton = true;
    },
    closePopupAndTrackImportProcess() {
      this.togglePopupEdit();
    },
    // #import
    rowAction(val) {
      this.$router.push(`/view-shipment/${this.listItem.id}`);
    },
    createNewShipment() {
      this.$router.push('/shipments/book-shipment');
    },
    optionSelected(opt) {
      if(opt === 'dropOption1') {
        this.createNewShipment();
      }
      if(opt === 'dropOption2') {
        this.openImportTemplatePopup();
      }
    },
    closeManualCancelPopup() {
      this.showManualCancelPopup = false;
      this.shippmentManualCancel = {};
    },
    actionOptionTriggered(option) {
      if(option.dropOption == 'dropOption1') {
        // Copy to new
        let shipmentId = this.get_shipments_list.filter((item) => item.id == option.list[0])[0].id;
        this.$store.dispatch('GET_SHIPMENT', shipmentId).then((res) => {
          this.$store.dispatch('SET_EDITING_SHIPMENT', res).then(() => {
            this.$router.push('book-shipment');
          });
        });
      }
      if(option.dropOption == 'dropOption2') {
        // Create EOD
        const currentIcon = this.actionsOptions[3].icon;
        this.actionsOptions[3].icon = 'animation';
        this.$store.dispatch('CREATE_EOD', option.list).then(() => {
          this.$router.push('end-of-day');
        });
      }
      if(option.dropOption == 'dropOption3') {
        //Print Waybills

        let ids = option.list
        if (this.isTableAllSelected) {
          ids = this.get_shipments_ids_of_all_records
          if (ids.length === 0) {
            this.$store.commit('SHOW_NOTIFICATION_BAR', {
              message: 'You can select max 500 shipments for this action!',
              type: 'alert-window'
            });
          }
        }

        if (ids.length) {
          this.$store.dispatch('DOWNLOAD_MULTI_LABELS', ids).then((res) => {
            this.$nextTick(() => {
              let file = window.URL.createObjectURL(res);
              this.$refs.downloadWaybillsPDF.href = file;
              this.waybillsPdfPath = file;
              this.$refs.downloadWaybillsPDF.click();
            })
          });
        }
      }
      if(option.dropOption == 'dropOption4') {

        const allowedToCancel = [];
        option.list.forEach(shippmentId => {
          const found = this.get_shipments_list.find(item => item.id == shippmentId);
          if (found && found.status != 5) {
            allowedToCancel.push(shippmentId);
          }
        })

        if (allowedToCancel.length > 0) {
          // Create EOD
          const currentIcon = this.actionsOptions[3].icon;
         // this.actionsOptions[3].icon = 'animation';

          this.$store.dispatch('CANCEL_SHIPMENT', option.list).then(r => {
            this.updateIterator++;
            const response = r.data.data;
            if (response.failed) {
              for (let shippmentId in response.failed) {
                this.$store.commit('SHOW_NOTIFICATION_BAR', {
                  message: response.failed[shippmentId].status,
                  type: 'alert-window',
                });
              }
            }
            if (response.success) {
              console.log(response.success)
              for (let shippmentId in response.success) {
                if (response.success[shippmentId].status === 'agent_does_not_have_cancel_option') {
                  const shippment = this.get_shipments_list.find(item => item.id == shippmentId);

                  if (!this.shippmentManualCancel[response.success[shippmentId].agent_id]) {
                    const agent = response.success[shippmentId].agent_info;
                    const carrierPhone = agent.phone;//shippment.custom_carrier ? shippment.custom_carrier.customer_service_phone : agent.phone;
                    const carrierEmail = agent.email; //shippment.custom_carrier ? shippment.custom_carrier.customer_service_email :  agent.email;
                    const agentName = agent.name; //shippment.custom_carrier ? shippment.custom_carrier.name : agent.name,

                    if (carrierPhone && carrierEmail) {
                      this.shippmentManualCancel[response.success[shippmentId].agent_id] = i18n.t('shipping_agent_does_not_have_cancel_option', {
                        carrier_name: agentName,
                        carrier_phone: carrierPhone,
                        carrier_email: carrierEmail,
                        trace_no: shippment.trace_no
                      });
                    } else if (carrierPhone) {
                      this.shippmentManualCancel[response.success[shippmentId].agent_id] = i18n.t('shipping_agent_does_not_have_cancel_option_without_email', {
                        carrier_name: agentName,
                        carrier_phone: carrierPhone,
                        trace_no: shippment.trace_no
                      });
                    } else if (carrierEmail) {
                      this.shippmentManualCancel[response.success[shippmentId].agent_id] = i18n.t('shipping_agent_does_not_have_cancel_option_without_phone', {
                        carrier_name: shippment.custom_carrier ? shippment.custom_carrier.name : agent.name,
                        carrier_email: carrierEmail,
                        trace_no: shippment.trace_no
                      });
                    } else {
                      console.log('phone and email not found. pls check')
                    }

                    if (parseInt(this.get_active_subaccount.backoffice_id) === 1) {
                      this.showManualCancelPopup = true;
                    } else {
                      this.$store.commit('SHOW_NOTIFICATION_BAR', {
                        message: i18n.t('shipment_is_cancelled'),
                        type: 'success-window',
                        iconName: 'check',
                      });
                    }
                  } else {
                    this.shippmentManualCancel[response.success[shippmentId].agent_id] += '<ul><li>'+ shippment.trace_no +'</li></ul>'
                  }
                }

                if (response.empty_pickups && response.empty_pickups.length > 0) {
                  this.emptyPickups = response.empty_pickups;
                  this.currentPickupIndex = 0;
                  this.showLastInPickupPopup = true;
                }
              }
            }
          }).finally(() => this.actionsOptions[3].icon = currentIcon);
        } else {
          this.updateIterator++;
        }
      }
    },
  },
};
</script>
